import { Worksheet } from '../../../types/worksheet';
import CalculationCard from '../../worksheet-v2/calculations/CalculationCard';
import PreviewSection from '../PreviewSection';

type CalculationsPreviewProps = {
    worksheet: Worksheet;
};

function CalculationsPreview({ worksheet }: CalculationsPreviewProps): JSX.Element {
    const calculations = worksheet.calculations;
    return (
        <PreviewSection title={`Calculations (${worksheet.calculations.length})`}>
            {calculations.length > 0 && (
                <div className="mt-2 px-4">
                    <div className="grid gap-2">
                        {worksheet.calculations.map((calc) => (
                            <CalculationCard calculation={calc} key={calc.id} worksheetId={worksheet.id} />
                        ))}
                    </div>
                </div>
            )}
        </PreviewSection>
    );
}

export default CalculationsPreview;
